<template>
    <sa-page-layout :btnSaveVisible="true" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <graffidi-applicativi-view-component @update="onUpdateJsonData"></graffidi-applicativi-view-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GraffidiApplicativiViewComponent from "../components/GraffidiApplicativiViewComponent.vue";
export default {
    components: { SaPageLayout, GraffidiApplicativiViewComponent },
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            linkback: "/graffidiapplicativi",
            jsonData: {},
            showModalLoading: false,
            pathResource: "/digitalsignapplicativi",
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
    },
};
</script>

<style></style>
